<template>
  <svg
    :class="cssClasses"
    :style="style">
    <use :xlink:href="iconPath" />
  </svg>
</template>

<script>
import IconLoader from './../helpers/IconLoader.js';
import SassColors from './../helpers/sass-colors.js';

export default {
  props: {
    'name': {
      default: '',
      type: String
    },
    'size': {
      default: '',
      type: String
    },
    'primaryColor': {
      default: '',
      type: String
    },
    'secondaryColor': {
      default: '',
      type: String
    },
    'strokeColor': {
      default: '',
      type: String
    },
    'properties': {
      default: '',
      type: String
    },
    'customCssClasses': {
      default: '',
      type: String
    },
    'customWidth': {
      default: '',
      type: String
    },
    'customHeight': {
      default: '',
      type: String
    }
  },
  name: 'icon',
  computed: {
    cssClasses () {
      let classes = {
        'icon': true,
        'size-xxxs': this.size === 'xxxs',
        'size-xxs': this.size === 'xxs',
        'size-xs': this.size === 'xs',
        'size-s': this.size === 's',
        'size-m': this.size === 'm',
        'size-l': this.size === 'l',
        'size-xl': this.size === 'xl',
        'size-xxl': this.size === 'xxl',
        'size-xxxl': this.size === 'xxxl',
        'is-clickable': this.properties.indexOf('is-clickable') > -1,
        'not-clickable': this.properties.indexOf('not-clickable') > -1
      };

      if (this.customCssClasses !== '') {
        let additionalCssClasses = this.customCssClasses.split(' ');

        for (let cssClass of additionalCssClasses) {
          classes[cssClass] = true;
        }
      }

      return classes;
    },
    style () {
      let style = [];

      if (this.primaryColor !== '' && SassColors[this.primaryColor]) {
        style.push(`fill: ${SassColors[this.primaryColor]}`);
      } else if (this.primaryColor === 'inherit') {
        style.push(`fill: inherit`);
      }

      if (this.secondaryColor !== '' && SassColors[this.secondaryColor]) {
        style.push(`color: ${SassColors[this.secondaryColor]}`);
      } else if (this.secondaryColor === 'inherit') {
        style.push(`fill: inherit`);
      }

      if (this.strokeColor !== '' && SassColors[this.strokeColor]) {
        style.push(`stroke: ${SassColors[this.strokeColor]}`);
      } else if (this.strokeColor === 'inherit') {
        style.push(`fill: inherit`);
      }

      if (this.customWidth !== '') {
        style.push(`width: ${this.customWidth}px`);
      }

      if (this.customHeight !== '') {
        style.push(`height: ${this.customHeight}px`);
      }

      return style.join(';')
    },
    iconPath () {
      return `#${this.name}`;
    }
  },
  mounted () {
    IconLoader.loaded();
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.icon {
  pointer-events: none;

  &.size-xxxs {
    height: 8px;
    width: 8px;
  }

  &.size-xxs {
    height: 12px;
    width: 12px;
  }

  &.size-xs {
    height: 16px;
    width: 16px;
  }

  &.size-s {
    height: 20px;
    width: 20px;
  }

  &.size-m {
    height: 24px;
    width: 24px;
  }

  &.size-l {
    height: 32px;
    width: 32px;
  }

  &.size-xl {
    height: 50px;
    width: 50px;
  }

  &.size-xxl {
    height: 100px;
    width: 100px;
  }

  &.size-xxxl {
    height: 200px;
    width: 200px;
  }

  &.is-clickable {
    pointer-events: auto;
  }

  &.not-clickable {
    pointer-events: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Icon.vue